export class Vermittlerdaten {
  vermittlerNummer: string;
  unternehmen: Unternehmen;
}

export class Unternehmen {
  unternehmensBezeichnung: string;
  vorname: string;
  nachname: string;
  externeReferenz: string;
  externeVermittlerNummer: string;
}

export function normalizeVermittlernummer(vermittlernummerInput: any): string {
  if (!vermittlernummerInput) {
    return '';
  }
  let result = (vermittlernummerInput + '').trim();
  if (result.length === 8) {
    result = result.substring(2, 8);
  }
  return result;
}
